import styled from '@emotion/styled';
import { Button } from 'common/components/Form/Button';

/** A white button with a thin border: the quiet counterpart to the purple primary button. `&&` outranks the base button's rules. */
export const SecondaryButton = styled(Button)<{ compact?: boolean; iconOnly?: boolean; danger?: boolean }>`
  && {
    height: ${({ compact }) => (compact ? 32 : 40)}px;
    padding: ${({ compact }) => (compact ? '0 12px' : '0 16px')};
    border: 1px solid ${({ theme, danger }) => (danger ? theme.colors.wine.toString() : theme.v2.colours.gray200)};
    border-radius: ${({ theme }) => theme.v2.borderRadius * 2}px;
    background: ${({ theme, danger }) => (danger ? theme.colors.wine.toString() : theme.v2.colours.gray0)};
    color: ${({ theme, danger }) => (danger ? theme.colors.white.toString() : theme.v2.colours.gray900)};
    font-size: ${({ compact }) => (compact ? '1.3rem' : '1.4rem')};
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    ${({ iconOnly, compact }) => (iconOnly ? `min-width: 0; width: ${compact ? 32 : 40}px; padding: 0;` : '')}
  }

  &&:hover:not(:disabled) {
    background: ${({ theme, danger }) => (danger ? theme.colors.wine.toString() : theme.v2.colours.gray50)};
    ${({ danger }) => (danger ? 'filter: brightness(0.92);' : '')}
  }

  &&:disabled {
    opacity: 0.4;
  }
`;
